<template>
  <div class="infor fl">
    <AllHeader
      :label="lable"
      :ischage="ischage"
      :sublabel="sublabel"
      :subtitle="subtitle"
      @getvalue="getvalue"
    />

    <!-- <Steps :list="list" :step="step" class="margin-bottom-40" /> -->
    <div class="stepContainer" v-if="list">
      <div v-for="(item,index) in list" :key="index">
        <div class="stepcone">
          <div class="line" v-if="index<=list.length-1" :style="{width:(10-list.length)*48+'%'}"></div>
          <div
            class="stepItem"
            :class="{'isactibe':item.success,'stponce':step==index,'error':isFail=='fail'&&step==2&&index==step}"
          >
            <i class="el-icon-check" v-if="(index+1<list.length)&&step!=index" style="color: white"></i>
            <span v-if="(index+1<list.length)&&step==index">{{index+1}}</span>
            <img src="../assets/np18.png" v-if="((step!=2)&&(index+1==list.length))" />
            <img src="../assets/18.png" v-if="((step==2)&&(index+1==list.length))" />
            <img src="../assets/down.png" v-if="step==index" alt class="downpng" />
          </div>
          <span v-if="(isFail=='fail'&&step==3&&index==step)" class="erroritem stepTitle">审核不通过</span>
          <span
            v-else
            class="stepTitle"
            :class="{'successtitle':item.success,'stpotitle':step==index,'erroritem':item.error}"
          >{{item.title}}</span>
        </div>
      </div>
    </div>
    <div v-if="step==0">
      <Lineconbgtir :labelcontainer="labelcontainerdeclare" />
      <div class="block-list">
        <div v-for="(item,index) in awardList" :key="index" class="block-list-item">
      <div class="block-list-item-r-t">{{ item.level }}</div>
          <div class="block-list-item-box">
            <div class="block-list-item-box-t">{{item.title}}</div>
            <div v-if="item.award_batches.length > 1">
              <el-carousel :interval="5000" arrow="always" :autoplay="false"  height="100px" width="370px">
                <el-carousel-item v-for="(bitem,index) in item.award_batches"  v-if="bitem.apply_at!=undefined &&  bitem.apply_at[0]<= now_date &&  bitem.apply_at[1] >= now_date "  :key="item">
                  <div  style="width:100% ;padding-top: 10px;">
                      <div class="bitem">
                          <div class="block-list-item-box-dtae">
                              {{bitem.year}}年度
                          </div>
                           <div
                                  class="block-list-item-box-b"
                                  :class="item.status==0?'block-list-item-box-b-d':''"
                                  @click="onApplyTap(item.id,item.status,item.title,bitem.content,bitem.file_urls,item.is_user,bitem.id,bitem.manual_url)">
                                  去申请
                              </div>
                       </div>
                      <div class="bitem">
                          <div class="block-list-item-box-startend" v-if="bitem.apply_at!=undefined">申报时间：{{ bitem.apply_at[0] }}~{{ bitem.apply_at[1] }}</div>
                      </div>
                  </div>
                </el-carousel-item>
              </el-carousel>


            </div>
            <div v-else-if="item.award_batches.length == 1" style="width:100%;">
                <div v-for="(bitem,index) in item.award_batches"  v-if="bitem.apply_at!=undefined &&  bitem.apply_at[0]<= now_date &&  bitem.apply_at[1] >= now_date ">
                  <div   style="width:100% ;padding-top: 10px;">
                      <div class="bitem">
                          <div class="block-list-item-box-dtae">
                              {{bitem.year}}年度
                          </div>
                           <div
                                  class="block-list-item-box-b"
                                  :class="item.status==0?'block-list-item-box-b-d':''"
                                  @click="onApplyTap(item.id,item.status,item.title,bitem.content,bitem.file_urls,item.is_user,bitem.id,bitem.manual_url)">
                                  去申请
                              </div>
                       </div>
                      <div class="bitem">
                          <div class="block-list-item-box-startend" v-if="bitem.apply_at!=undefined">申报时间：{{ bitem.apply_at[0] }}~{{ bitem.apply_at[1] }}</div>
                      </div>
                  </div>
                </div>
            </div>
            <div v-else class="nobatch" style="width:100%;">
                该项目暂无申报
            </div>



          </div>


        </div>
      </div>

    </div>
    <div v-if="step==1">
      <Lineconbgtir :labelcontainer="labelcontainertow" />
      <p style="margin-top:40px;text-align:start">本项目为线上申报，请点击下方按钮进入申报表单填报页面</p>
      <Downinpu :downlist="downlist" />
      <!-- <div class="infor-c" v-html="content">

      </div> -->

      <Lineconbgtir :labelcontainer="Documentedit" class="margin-top-40" />
        <el-button
          icon="el-icon-edit"
          style="color:#194ABE;border:1px solid #194ABE;width:189px;height:50px;font-size:18px;margin-top:50px"
          size="small"
          :disabled="false"
          @click="startdata"
        >开始填写资料</el-button>
        <div v-if="id==9">
        <div class="block-solid"></div>
        <Lineconbgtir v-if="id!=9" :labelcontainer="labelcontainer" class="margin-top-40" />
        <div v-if="id!=9" class="upload margin-top-40">
          <el-upload
            class="upload-demo"
            :action="$baseURL+'/api/home/upload/file/award_log'"
            :on-preview="handlePreview"
            :data="{token:token}"
            accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-success="handleAdd"
            :on-error="handleError"
            list-type="text"
          >
            <div class="uploadheader">
              <span>上传文件</span>
              <el-button size="small" icon="el-icon-upload2" style="color: #194ABE">点击选择文件</el-button>
              <span v-if="showErr" class="el-upload__tip margin-left-30" slot="tip">
                <i class="el-icon-error"></i>支持格式：doc,docx,xls,xlsx,ppt,pptx,pdf,zip,rar&nbsp;&nbsp;(请上传小于50M的文件)。
              </span>
            </div>
          </el-upload>
          <div class="flex-left" style="margin:0 auto">
            <el-button
              size="small"
              icon="el-icon-check"
              style="background-color: #194ABE;color: white;margin-bottom: 20px;"
              class="block-submit"
              @click="onSubmitTap"
            >提交审核</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="false">
      <div v-if="isFail=='fail'">
        <div class="shenhjrkr">
          <img src="../assets/faile.png" alt />
          <p style="font-size: 20px;color:#333333">审核未通过</p>
          <p style="font-size: 16px;color: #E51725;margin: 10px 0">未通过原因：{{reason}}</p>
          <p style="font-size: 16px;color: #9FA5AE;margin: 10px 0">请修改后重新提交</p>
            <div class="flex-left">
              <el-button
                size="small"
                icon="el-icon-edit"
                style="color:#194ABE;border:1px solid #194ABE;width:189px;height:50px;font-size:18px;margin-top:50px;background:#fff;margin:0 auto"
                class="block-submit"
                @click="now_modify"
              >现在去修改</el-button>
            </div>
        </div>
        <!-- <Lineconbgtir :labelcontainer="labelcontaineragain" style="margin-top: 20px" /> -->
        <!-- <div class="upload">
          <el-upload
            class="upload-demo"
            action="http://gzjzyxh.tooge.cn/api/home/upload/file/award_log"
            :on-preview="handlePreview"
            :data="{token:token}"
            accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-success="handleAdd"
            :on-error="handleError"
            list-type="text"
          >
            <div class="uploadheader">
              <span>上传文件</span>
              <el-button size="small" icon="el-icon-upload2" style="color: #194ABE">点击选择文件</el-button>
              <span v-if="showErr" class="el-upload__tip margin-left-30" slot="tip">
                <i class="el-icon-error"></i>支持格式：doc,docx,xls,xlsx,ppt,pptx,pdf,zip,rar&nbsp;&nbsp;(请上传小于50M的文件)。
              </span>
            </div>
          </el-upload>
        </div> -->

        <!-- <div class="flex-left">
          <el-button
            size="small"
            icon="el-icon-check"
            style="background-color: #194ABE;color: white;margin-bottom: 20px"
            class="block-submit"
            @click="onSubmitTap"
          >提交审核</el-button>
        </div> -->
      </div>
      <div v-if="isFail=='response'">
        <div class="shenhjrkr">
          <img src="../assets/failesucee.png" alt />
          <p style="font-size: 20px;color:#333333">已通过平台审核</p>
          <p style="font-size: 16px;color: #9FA5AE;margin: 10px 0">请下载您所提交资料的打印文件，打印后补充盖章、日期、签名等空缺</p>
            <div class="flex-left">
              <el-button
                size="small"
                icon="el-icon-printer"
                style="color:#194ABE;border:1px solid #194ABE;width:189px;height:50px;font-size:18px;margin-top:50px;background:#fff;margin:0 auto"
                class="block-submit"
                @click="now_modify"
              >下载打印文件</el-button>
            </div>
        </div>
        <Lineconbgtir :labelcontainer="labelcontaineragain" style="margin-top: 20px" />
        <p style="font-size: 16px;color: #9FA5AE;margin: 10px 0 0 ;text-align:start">下载打印文件并补充盖章、日期、签名后，将表单内容以电子档形式上传，提交审核后进入下一流程。</p>
        <div class="upload">
          <el-upload
            class="upload-demo"
            action="http://gzjzyxh.tooge.cn/api/home/upload/file/award_log"
            :on-preview="handlePreview"
            :data="{token:token}"
            accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-success="handleAdd"
            :on-error="handleError"
            list-type="text"
          >
            <div class="uploadheader">
              <span>上传文件</span>
              <el-button size="small" icon="el-icon-upload2" style="color: #194ABE">点击选择文件</el-button>
              <span v-if="showErr" class="el-upload__tip margin-left-30" slot="tip">
                <i class="el-icon-error"></i>支持格式：doc,docx,xls,xlsx,ppt,pptx,pdf,zip,rar&nbsp;&nbsp;(请上传小于50M的文件)。
              </span>
            </div>
          </el-upload>
        </div>
        <div class="flex-left">
          <el-button
            size="small"
            icon="el-icon-check"
            style="background-color: #194ABE;color: white;margin-bottom: 20px"
            class="block-submit"
            @click="onSubmitTap"
          >提交专家审核</el-button>
        </div>
      </div>
      <div class="shenhjrkr" v-if="isFail=='pending'">
        <img src="../assets/shenhr.png" alt />
        <p style="font-size: 16px;color: #333333">正在审核中...</p>
        <p style="font-size: 10px;color: #9FA5AE;margin: 10px 0">正在审核您提交的资料，请稍后查看结果</p>
      </div>
    </div>
    <div v-if="false">
      <div v-if="!address">
        <div class="shenhjrkr">
          <img src="../assets/failesucee.png" alt />
          <p style="font-size: 20px;color: #333333">项目申请成功</p>
          <p style="font-size: 16px;color: #9FA5AE;margin: 10px 0">请填写您的收取地址并提交</p>
        </div>
        <div>
          <el-input
            type="textarea"
            rows="5"
            placeholder="请输入您的收货地址"
            v-model="textarea"
            class="textarea"
          ></el-input>
        </div>
        <el-button
          type="primary"
          icon="el-icon-check"
          style="background-color:#194ABE"
          size="small"
          class="block-submit"
          @click="onAddressTap"
        >提交地址</el-button>
      </div>
      <div v-else>
        <div class="shenhjrkr">
          <img src="../assets/failesucee.png" alt />
          <p style="font-size: 20px;color: #333333">项目申请成功</p>
          <p
            style="font-size: 16px;color: #9FA5AE;margin: 10px 0"
          >我们会尽快将项目证书发放给您，如需修改地址请联系400-888-8888</p>
          <div class="block-addr">
            <span class="span-l">已提交的收货地址：</span>
            <span class="span-r">{{address}}</span>
            <!-- <el-input type="textarea" rows="5" placeholder="请输入您的收货地址" v-model="textarea" class="textarea">
            </el-input>-->
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="温馨提示" :visible.sync="dialogVisible" width="474px" :before-close="handleClose" >
        <div class="yellow-box" style="font-size:18px">
            {{member_tip}}
        </div>
        <span slot="footer" class="dialog-footer" style="text-align:center;">
          <el-button v-if="is_user == 1"
            type="primary"
            icon="el-icon-check"
            @click="toPay"
            >去缴费</el-button >
            <el-button v-if="is_user == 0"
            type="primary"
            icon="el-icon-check"
            @click="toJoin"
            >申请会员</el-button >
        </span>
      </el-dialog>

  </div>


</template>

<script>
import AllHeader from "@/components/Modal/AllHeader";
// import Steps from "@/components/Modal/Steps";
import Lineconbgtir from "./Modal/Line";
import Downinpu from "@/components/Modal/Downinpu";
import Pagetion from "@/components/Modal/Pagetion";
import {
  AwardList,
  AwardInfo, //申报记录详情
  AwardInfobatch,
  AwardLog, //申报奖项
  Address //填写地址
} from "../utils/api.js";
export default {
  name: "declear",
  components: {
    AllHeader,
    // Steps,
    Lineconbgtir,
    Downinpu,
    // Pagetion
  },
  data() {
    return {
      faile:false,
      content:'',
      modifyID:'',
      showErr: false,
      isFail: 'pending', //审核状态是否失败 fail(失败) pending(审核中) response(成功)
      id: "",
      award_batch_id:0,
      token: "",
      total: 0,
      pageSize: 100,
      lable: "",
      step: 0,
      fileList: [],
      ischage: false,
      sublabel: "返回项目列表",
      textarea: "",
      subtitle: "", //副标题
      labelcontainertow: {
        lable: "申请须知",
        desc: "Application Notes"
      },
      Documentedit:{
        lable: "填写申请表单",
        desc: "Document edit"
      },
      labelcontainerdeclare: {
        lable: "请选择您要申报的项目",
        desc: ""
      },
      labelcontainer: {
        lable: "开始上传,线下材料提交窗口",
        desc: "Document download"
      },
      labelcontaineragain: {
        lable: "上传完善后的表单",
        desc: "Document download"
      },
      labelcontainerdow: {
        lable: "申请文档下载",
        desc: "Document download"
      },
      downlist: [
        {
          name: "会员申请表",
          url: "2021年优秀企业申报表.doc"
        }
      ],
      list: [
        {
          title: "选择项目",
          isred: true
        },
        {
          title: "资料上传",
          isred: true
        },
          {
              title: "平台审核",
              isred: true
          },

        {
          title: "专家审核",
          isred: true
        },
        {
          title: "完成",
          isred: true
        }
      ],
      awardList: [], //奖项列表
      address: "", //收货地址
      reason: "", //审核未通过原因
      file_urls: [],
      now_date:'',
      member_tip:'',
      is_user:0,
      dialogVisible:false
    };
  },
  mounted() {
    this.lable = this.$route.query.name;
    this.token = "Bearer " + localStorage.getItem("TOKEN");
    this.initList(1);
    const now = new Date();
    const year = now.getFullYear();
    const month = ('0' + (now.getMonth() + 1)).slice(-2);
    const day = ('0' + now.getDate()).slice(-2);
    this.now_date = year+'-'+month+'-'+day;
  },

  methods: {
    async initList(page) {
      const data = {
        page_size: this.pageSize,
        page: page
      };
      let res = await AwardList(data);
      this.awardList = res.data || [];
      console.log(996,this.awardList);
      for(var i=0; i < this.awardList.length; i++){
          var award_batches = [];
          console.log('this.awardList.award_batches',this.awardList[i].award_batches)
          if(this.awardList[i].award_batches){
              for(var j = 0; j < this.awardList[i].award_batches.length; j++){
                  var bitem = this.awardList[i].award_batches[j];
                  console.log('bitem',bitem);
                  console.log('now_date',this.now_date);
                  if(bitem.apply_at!=undefined &&  bitem.apply_at[0]<= this.now_date &&  bitem.apply_at[1] >= this.now_date ){
                      console.log('bitempush ',bitem);
                      award_batches.push(bitem);
                  }
              }
          }
          this.awardList[i].award_batches = award_batches;
      }
      this.total = res.total;
    },
    // 去申请查看申请信息
    onApplyTap(id, status, title,content,file_urls,is_user,award_batch_id = 0, manualUrl = '') {
      console.log('this.$store.state',this.$store.state)
        this.award_batch_id = award_batch_id;
        if (this.$store.state.level==0&&is_user==1) {
          this.member_tip = '该项目是会员申报项目，请先申请入会';
          this.dialogVisible = true;
          this.is_user = 0;
          console.log('member_tip',this.member_tip)
          return false
        }
      if (this.$store.state.applayoverdue==false&&is_user==1) {
          this.member_tip = '贵单位的会员已过期，请续费后申报！';
          this.dialogVisible = true;
          this.is_user = 1;
          console.log('member_tip',this.member_tip)
         return false
       }
       console.log('id',id);
       if(id == 13){
           this.list = [
        {
          title: "选择项目",
          isred: true
        },
        {
          title: "资料上传",
          isred: true
        },
          {
              title: "平台审核",
              isred: true
          },

        {
          title: "验收评价",
          isred: true
        },
        {
          title: "完成",
          isred: true
        }
      ];
       }
      //if(id==12){
      //   this.$message.error('该奖项申报暂已关闭！')
      //   return false
      //}
      if (status) {
        AwardInfobatch(id,award_batch_id)
          .then(res => {
            console.log(789,res.status);
            this.step = 1;
            this.ischage = false;
            this.id = id;
            // if (res.award_id) {
            //   this.id = res.id;
            //   this.modifyID = res.award_id;
            //   if (res.status == 3) {
            //     //审核不通过
            //     this.step = 2;
            //     this.isFail = 'fail';
            //     this.reason = res.reject_reason || "";
            //   } else if (res.status == 2) {
            //     //审核通过
            //     this.step = 2;
            //     this.isFail = 'response';
            //     this.address = res.address || "";
            //   }
            //    else {
            //     this.step = 2;
            //   }
            // } else {
            //   //去填写资料
            //   this.step = 1;
            //   this.ischage = false;
            //   this.id = id;
            // }
            this.ischage = true;
            this.subtitle = title;
          })
          .catch(err => {
            if ( err == '非会员' ) {
                this.member_tip = '该项目是会员申报项目，请先申请入会';
                this.dialogVisible = true;
                this.is_user = 0;
              }else if ( err == '会员过期' ) {
                this.member_tip = '贵单位的会员已过期，请续费后申报！';
                this.dialogVisible = true;
                this.is_user = 0;
             } else {
               this.$message.error(err);
             }

          });
      }
      this.content = content
      const downlist = Array.isArray(file_urls) ? file_urls.slice() : []
      if (Number(id) === 21 && manualUrl && !downlist.some(item => item && item.url === manualUrl)) {
        downlist.unshift({ name: '操作指南', url: manualUrl })
      }
      this.downlist = downlist
    },
    handleAdd(response, file, fileList) {
      // console.log(response);
      // console.log(file);
      // console.log(fileList);
      this.setUrls(fileList);
      // this.fileList = fileList
      // this.ruleForm.business_license = response.data.host + response.data.url
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
      this.setUrls(fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    //获取上传数组
    setUrls(fileList) {
      let urls = [];
      fileList.map(item => {
        urls.push(item.response.data.host + item.response.data.url);
      });
      this.file_urls = urls;
      console.log(this.file_urls);
    },
    handleError(err, file, fileList) {
      // console.log(err, file, fileList);
      this.showErr = true;
      let that = this;
      setTimeout(function() {
        that.showErr = false;
        console.log(that.showErr);
      }, 2000);
      // console.log(this.showErr);
    },
    toPay(){
         this.$router.push('/member/renew')
      },
      toJoin(){
         this.$router.push('/member/apply')
        },
    handleClose(done) {
      done();
    },
    //现在去修改
    now_modify(){
      this.$router.push(`/form?title=${this.subtitle}&id=${this.modifyID}`)
    },
    //开始填写资料
    startdata(){
      this.$router.push(`/form?title=${this.subtitle}&id=${this.id}&award_batch_id=${this.award_batch_id}`)
    },
    // 提交审核
    onSubmitTap() {
      if (this.file_urls.length && this.id) {
        const data = {
          award_id: this.id,
          file_urls: this.file_urls
        };
        console.log(data);
        AwardLog(data).then(res => {
          if (res) {
            this.$message({
              type:'success',
              message:'申报成功'
            })
            this.step = 0;
            this.isFail = false;
          }
        });
      } else {
        this.$message({
          message: "请上传文档",
          type: "warning"
        });
      }
    },
    // 提交地址
    async onAddressTap() {
      if (this.textarea) {
        let id = this.id;
        let addr = this.textarea;
        Address(id, addr)
          .then(res => {
            this.address = addr;
          })
          .catch(err => {
            this.$message.error(err.response.data.message);
          });
      } else {
        this.$message.warning("请填写地址");
      }
    },
    getvalue() {
      this.step = 0;
      this.ischage = false;
      this.subtitle = "";
    },

    getpageValue(index) {
      // console.log(index);
      this.initList(index);
    }
  }
};
</script>

<style scoped lang="less">

/deep/.block-title {
  border-left: 3px solid #194ABE !important;
}
/deep/.el-upload-list{
  display: flex;
  flex-direction: column;
  text-align: start;
  height: 100%;
}

.textarea {
  width: 382px;
  // height: 92px;
  background: #ffffff;
  border: 1px solid #bdc3cb;
  opacity: 1;
  border-radius: 4px;
}

.block-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px 0;

  &-item {
    width: 370px;
    background: #ffffff;
    border: 1px dashed #c8cdd5;
    padding: 24px 25px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 21px;
  position: relative;
  &-r-t{
    position: absolute;
    top: 0;
    right: 0;
    width: 73px;
    height: 27px;
    background: #F5F9FB;
    opacity: 1;
    border-radius: 0px 0px 0px 80px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 27px;
    color: #C6C9CE;
    padding-left: 10px;
    box-sizing: border-box;
  }
    &-box {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: flex-start;
      &-t {
        width: 244px;
        color: #0c0d0f;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-align: justify;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
      }
      &-dtae {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 26px;
        color: #194abe;
      }
      &-startend {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #7c828a;
        margin-right:20px;
      }
      &-b {
        width: 91px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #194abe;
        color: #194abe;
        opacity: 1;
        border-radius: 6px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        cursor: pointer;
      }

      &-b-d {
        background: #ffffff !important;
        border: 1px solid #d4dbdd !important;
        color: #c8cdd5 !important;
      }

      &-b-s {
        background: #d4dbdd !important;
        border: 1px solid #d4dbdd !important;
        color: #ffffff !important;
      }
    }
  }
}

.margin-bottom-40 {
  margin-bottom: 40px;
}

.infor {
  padding-bottom: 40px;
  min-height: 800px;
  margin-bottom: 34px;
  position: relative;
}

.upload-demo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.uploadheader {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;

  span {
    margin-right: 10px;
    color: #71767c;
  }
}

.margin-top-40 {
  margin-top: 40px;
}

.block-solid {
  width: 100%;
  height: 2px;
  background-color: #e51725;
  margin-top: 30px;
}

.shenhjrkr {
  margin: 71px 0 100px 0;

  img {
    width: 120px;
  }
}

.stepContainer {
  width: 100%;
  height: 160px;
  background-color: #f6f6f6;
  margin: 20px 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  overflow: hidden;

  .stepcone {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .stepItem {
      width: 50px;
      height: 50px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #9fa5ae;
      border: 1px solid #9fa5ae;
      font-size: 32px;
      font-weight: 900;
      color: #c8cdd5;
      z-index: 999;

      .downpng {
        position: absolute;
        top: -20px;
        width: 20px;
        height: auto;
      }
    }

    img {
      width: 27px;
      height: auto;
    }

    .isactibe {
      color: white;
      // border: 1px solid #9FA5AE;
      // background-color: #9FA5AE;
    }

    .stponce {
      color: #194abe;
      border: 1px solid #194abe;
      background-color: white;
    }

    .error {
      color: #e51725;
      border: 1px solid #e51725;
      background-color: white;
    }

    .stepTitle {
      font-size: 18px;
      color: #c8cdd5;
      margin-top: 10px;
    }

    .successtitle {
      color: #0c0d0f;
    }

    .stpotitle {
      color: #194abe;
    }

    .erroritem {
      color: #e51725;
    }

    .line {
      width: 350%;
      flex: 1;
      flex-shrink: 0;
      height: 2px;
      border-bottom: 1px dashed #d4dbdd;
      position: absolute;
      top: 25px;
      left: 85%;
    }
  }
}
.block-addr {
  display: inline-block;
  padding: 13px 32px;
  background-color: #fff7e8;
  font-size: 14px;
  margin-top: 31px;
  .span-l {
    color: #9fa5ae;
  }
  .span-r {
    color: #194abe;
  }
}
.bitem {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.nobatch {
     font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 26px;
    color: #7c828a;
    text-align: left;
    margin-top: 10px;
        padding-left: 25px;
  }
  .block-list-item-box-t {
      padding-left: 25px;
    padding-right: 25px;
    margin-bottom: 10px;
    width: auto;
    overflow: hidden;
  }
  .block-list-item {
      align-items: flex-start !important;
      padding:24px 0px !important;
      width: 420px !important;
      height: 120px !important;
  }
  .block-list-item-box {
    justify-content: flex-start !important;
    align-items: flex-start;
    min-height: 100px !important;
    width:100% !important;
  }

  .el-carousel--horizontal {
    overflow-x: hidden;
    width: 420px;
}
.el-carousel__arrow--left {
    left: 0px !important;
}
.el-carousel__arrow--right {
    right: 0px !important;
}
.bitem {
    padding-left: 40px  !important;
    padding-right: 40px  !important;
}
.el-carousel__arrow:nth-child(2n) {
    right: 2px !important;
  }
 .el-carousel__arrow:nth-child(2n+1) {
    left: 2px !important;
  }
 .el-carousel--horizontal button:nth-child(2n) {
    right: 2px !important;
}
 .el-carousel--horizontal button:nth-child(2n+1) {
    left: 2px !important;
}
</style>
